import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatError } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account created");
      nav("/");
    } catch (err) { toast.error(formatError(err)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-background p-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="font-serif text-3xl mb-6">Create account</h1>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Name</Label><Input data-testid="register-name-input" required value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/></div>
          <div><Label>Email</Label><Input data-testid="register-email-input" type="email" required value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/></div>
          <div><Label>Password</Label><Input data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={e=>setForm({...form,password:e.target.value})}/></div>
          <Button type="submit" data-testid="register-submit-btn" disabled={loading} className="w-full">{loading? "Creating…" : "Create account"}</Button>
          <Link to="/login" className="text-sm block text-muted-foreground">Back to sign in</Link>
        </form>
      </Card>
    </div>
  );
}
